import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectedAuthor } from "../../features/filter/filterSlice";
import { removeVideo } from "../../features/updateLikeUnlike/updateLikeUnlikeSlice";

const VideoGridItem = ({ videoInfo = {} }) => {
    const { id, title, duration, thumbnail, avatar, author, views, date } =
        videoInfo;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSelectedAuthor = (author) => {
        dispatch(selectedAuthor(author));
    };

    const handleDynamicRoute = () => {
        /*Removing the updateLikeUnlikeSlice state video 
        so that for the first time we can get the initial video info,
        then we can update like and unlike on every click on the UI 
        without **Rerender** the whole Component everyTime.*/
        dispatch(removeVideo());

        navigate(`/videos/${id}`);
    };

    return (
        <div className="col-span-12 sm:col-span-6 md:col-span-3 duration-300 hover:scale-[1.03]">
            <div className="w-full flex flex-col">
                <div className="relative">
                    <div
                        className="cursor-pointer"
                        onClick={handleDynamicRoute}
                    >
                        <img
                            src={thumbnail}
                            className="w-full h-auto"
                            alt={title}
                        />
                    </div>

                    <p className="absolute right-2 bottom-2 bg-gray-900 text-gray-100 text-xs px-1 py">
                        {duration}
                    </p>
                </div>

                <div className="flex flex-row mt-2 gap-2">
                    <div
                        onClick={() => handleSelectedAuthor(author)}
                        className="shrink-0 cursor-pointer"
                    >
                        <img
                            src={avatar}
                            className="rounded-full h-6 w-6"
                            alt={author}
                        />
                    </div>

                    <div clas="flex flex-col">
                        <div
                            className="cursor-pointer"
                            onClick={handleDynamicRoute}
                        >
                            <p className="text-slate-900 text-sm font-semibold">
                                {title}
                            </p>
                        </div>
                        <div
                            className="cursor-pointer text-gray-400 text-xs mt-2 hover:text-gray-600"
                            onClick={() => handleSelectedAuthor(author)}
                        >
                            {author}
                        </div>
                        <p className="text-gray-400 text-xs mt-1">
                            {views} views . {date}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoGridItem;
